import React from "react"

import InputTextElement from "./InputTextElement";

const InputTextControl = ({
    handleSubmit = () => {},
    editing,
    required,
    name,
    label,
    autoFocus,
    placeholder,
    type = "text",
    hint,
    icon,
    haserror,
    disabled,
    readonly,
    className = "",
    watchfunction = null,
    mirrorField = null,
    value,
    onChange,
    error,
}) => {
    
    if (!editing) readonly = true;

    const onKeyDown = (e) => {
        if (e.keyCode === 13){
            // handleSubmit && handleSubmit();
        }

    }

    return (
        <InputTextElement
            id={name}
            name={name}
            value={value}
            type={type}
            label={label}
            placeholder={placeholder}
            icon={icon}
            hint={hint}
            error={error}
            invalid={Boolean(error) || haserror}
            editing={editing}
            required={required}
            autoFocus={autoFocus}
            disabled={disabled}
            readonly={readonly}
            className={className}
            onChange={onChange}
            onKeyDown={onKeyDown}
            watchfunction={watchfunction}
            mirrorField={mirrorField}
        />
    );
};


export default InputTextControl;
